var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"name-wrapper",attrs:{"href":_vm.$router.resolve({name: 'ViewUser', params: {id: _vm.user.id}}).href,"target":"_blank"}},[_c('UserAvatar',{attrs:{"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }